import z from 'zod'
import { COURSE_STATUS } from '@/constants/course-status'

export const previousCourseSchema = z.object({
  id: z.string().optional(),
  name: z.string().trim().min(1),
  workload: z.coerce.number().min(1),
  finalNumericGrade: z
    .string()
    .trim()
    .regex(/^\d{1,2}(\.\d{1,2})?$/),
  period: z.string().trim().min(1)
})

export const desiredCourse = z.object({
  id: z.string().optional(),
  name: z.string().trim().min(1),
  workload: z.coerce.number().min(0),
  courseId: z.string().trim().min(1),
  serie: z.string().optional(),
  period: z.string().optional()
})

export const equivalenceStatus = z.object({
  id: z.enum([
    COURSE_STATUS.GRANT.id,
    COURSE_STATUS.ADAPTATION.id,
    COURSE_STATUS.NOT_GRANT.id
  ])
})

export const previousEducationsSchema = z.object({
  previousCourseName: z.string().trim().min(1, 'Campo obrigatório'),
  previousInstituitionName: z.string().trim().min(1, 'Campo obrigatório'),
  modality: z.string().trim().min(1, 'Selecione uma opção'),
  educationLevel: z.string().trim().min(1, 'Selecione uma opção'),
  file: z.instanceof(File, { message: 'Histórico Obrigatório' }).optional()
})

export const desiredEducationSchema = z.object({
  desiredEducationId: z.string().min(1, 'Selecione um curso'),
  desiredEducationName: z.string().optional()
})

export const courseEquivalenceSchema = z.array(
  z
    .object({
      previousCourse: previousCourseSchema.optional(),
      desiredCourse: desiredCourse,
      equivalenceStatus: equivalenceStatus.optional(),
      selectedByAI: z.boolean().optional()
    })
    .superRefine((data, ctx) => {
      if (
        data.equivalenceStatus?.id !== COURSE_STATUS.ADAPTATION.id
        && !data.previousCourse
      ) {
        ctx.addIssue({
          code: 'custom',
          message: 'Campos obrigatórios',
          path: ['previousCourse']
        })
      }
    })
)

export const matchCourseSchema = z.object({
  previousEducation: previousEducationsSchema.optional(),
  desiredEducation: desiredEducationSchema.optional(),
  observation: z.string(),
  curriculum: z.string(),
  serie: z.string().min(1, 'Selecione uma Série'),
  automaticCourseEquivalences: z.array(
    z
      .object({
        previousCourse: previousCourseSchema,
        desiredCourse: desiredCourse,
        equivalenceStatus: equivalenceStatus.optional(),
        selectedByAI: z.boolean()
      })
      .optional()
  ),
  courseEquivalences: courseEquivalenceSchema
})

export type PreviousCoursesFormType = z.infer<typeof previousCourseSchema>
export type DesiredCourseFormType = z.infer<typeof desiredCourse>
export type EquivalenceStatusType = z.infer<typeof equivalenceStatus>
export type MatchCoursesFormType = z.infer<typeof matchCourseSchema>
export type PreviousEducationFormType = z.infer<typeof previousEducationsSchema>
export type DesiredEducationFormType = z.infer<typeof desiredEducationSchema>
export type EquivalenceStatusFormType = z.infer<typeof equivalenceStatus>
export type CourseEquivalenceFormType = z.infer<typeof courseEquivalenceSchema>
